module.exports = __webpack_public_path__ + "static/media/flag-us.537bbe5f.png";